const rangeSliderElem = document.querySelector('.range-slider');

if (rangeSliderElem) {
  const updateInputValue = (inputField, newValue) => {
    inputField.value = newValue; // Update the value programmatically

    // Create and dispatch the input event
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    inputField.dispatchEvent(event);
  };

  document.querySelectorAll('#range-slider-input').forEach((el) => {
    const parentEle = el.closest('.range-slider');
    const rangeStartInput = parentEle?.querySelector('.range-slider__start-range input');
    const rangeEndInput = parentEle?.querySelector('.range-slider__end-range input');

    const rangeMin = parseInt(el.getAttribute('data-min') || 0, 10);
    const rangeMax = parseInt(el.getAttribute('data-max') || 3, 10);
    const rangeFrom = parseInt(el.getAttribute('data-from') || rangeMin, 10);
    const rangeTo = parseInt(el.getAttribute('data-to') || rangeMax, 10);
    const rangeSteps = parseInt(el.getAttribute('data-steps') || 1, 10);

    noUiSlider.create(el, {
      start: [rangeFrom, rangeTo],
      connect: true,
      direction: 'ltr',
      range: { min: rangeMin, max: rangeMax },
      step: rangeSteps,
      tooltips: false,
      format: wNumb({ decimals: 1 }),
    });

    const dataValues = el
      .getAttribute('data-values')
      ?.split(',')
      .map((value) => value.trim());

    el.noUiSlider.on('update', (values, handle) => {
      if (dataValues) {
        const valueLabel = dataValues[Math.round(values[handle])];
        if (handle === 0) {
          rangeStartInput.setAttribute('value', valueLabel);
          updateInputValue(rangeStartInput, valueLabel); // Update the start input
        } else {
          rangeEndInput.setAttribute('value', valueLabel);
          updateInputValue(rangeEndInput, valueLabel); // Update the end input
        }
      } else {
        [rangeStartInput, rangeEndInput][handle].setAttribute('value', values[handle]);
        updateInputValue([rangeStartInput, rangeEndInput][handle], values[handle]); // Fire the input event for both
      }
    });
  });

  window.addEventListener('load', () => {
    // Check if the URL contains the start and end parameter
    const urlParams = new URLSearchParams(window.location.search);
    const start = urlParams.get('start');
    const end = urlParams.get('end');

    const slider = document.getElementById('range-slider-input');

    if (slider && start && end) {
      slider.noUiSlider.set([start - 1, end - 1]);
    }
  });
}
